import React, { useId } from 'react';
import { Chip } from 'primereact/chip';

import '../static/styles/TagPreview.css';

const DEFAULT_VISIBLE_TAGS = 3;

export default function TagPreview({ tags = [], full = false }) {
    const tooltipId = useId();

    if (!Array.isArray(tags) || tags.length === 0) {
        return <span className="tag-preview__empty">No topics listed</span>;
    }

    const uniqueTags = Array.from(new Set(tags.filter(Boolean)));

    if (full) {
        return (
            <div className="tag-preview tag-preview--full">
                {uniqueTags.map((tag) => (
                    <Chip key={tag} label={tag} />
                ))}
            </div>
        );
    }

    const visibleTags = uniqueTags.slice(0, DEFAULT_VISIBLE_TAGS);
    const hasOverflow = uniqueTags.length > DEFAULT_VISIBLE_TAGS;

    return (
        <div className="tag-preview">
            {visibleTags.map((tag) => (
                <Chip key={tag} label={tag} />
            ))}
            {hasOverflow && (
                <div className="tag-preview__more" tabIndex={0} aria-describedby={tooltipId}>
                    <i className="pi pi-ellipsis-h" aria-hidden="true" />
                    <div className="tag-preview__tooltip" id={tooltipId} role="tooltip">
                        {uniqueTags.map((tag) => (
                            <span key={tag} className="tag-preview__tooltip-item">{tag}</span>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
}
